import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import { Button } from 'reactstrap';

import { getBrandDetails } from '../redux/actions/data/brandActions';
import history from '../utils/createHistory';

const BrandPreview = () => {
  const dispatch = useDispatch();
  const { id } = useParams();

  const {
    loading,
    settingData: brandInfo,
    error,
  } = useSelector(state => state.brandDetails);

  useEffect(() => {
    dispatch(getBrandDetails(id));
  }, []);

  const [browser, setBrowser] = useState('PC');

  useEffect(() => {
    if (window.innerWidth < 767) {
      setBrowser('mobile');
    }
  }, []);

  const handleGoBack = () => {
    history.goBack();
  };

  return (
    <>
      {!loading && (
        <div className="preview">
          <Button
            className="preview_button_cancel btn btn-light"
            onClick={handleGoBack}
          >
            取消預覽
          </Button>
          <div className="hero brand-hero">
            <img
              src={brandInfo.bannerUrl}
              alt={brandInfo.name}
              className="mi-desktop"
            />
            <img
              src={brandInfo.logoUrl}
              alt={brandInfo.logoUrl}
              style={{width: '100%',
                maxWidth: '400px',
                objectFit: 'contain',
                left: '50%',
                transform: 'translateX(-50%)'}}
            />
          </div>

          <main>
            <div
              className={
                brandInfo.introColor === 'white'
                  ? 'brand-intro-wrap text-white'
                  : 'brand-intro-wrap text-black'
              }
              style={{
                background: brandInfo.bgColor_bottom,
              }}
            >
              <svg
                className="brand-bg-front"
                style={{
                  fill: brandInfo.bgColor_top,
                }}
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 1920 1080"
              >
                <polygon points="1920 415.52 1062 1080 0 1080 0 0 1920 0 1920 415.52" />
              </svg>
              <div
                className="brand-intro clearfix"
                style={
                  browser === 'mobile'
                    ? {
                        background: brandInfo.bgColor_top,
                      }
                    : {}
                }
              >
                <div className="brand-intro wrap-lg" style={{
                  position: 'relative',
                  display: 'flex',
                  padding: '70px 50px',
                  alignItems: 'center',
                  gap: '50px',
                }}>
                  <img
                    className=""
                    style={{
                      zIndex: 2,
                      position: 'relative',
                      maxWidth: '50%',
                    }}
                    src={brandInfo.introBlockImgUrl}
                    alt=""
                  />
                  <div className="" style={{zIndex: 2,}}>
                    <p style={{fontSize: '42px', lineHeight: '57.2px', fontWeight:'bold'}}>{brandInfo.introTitle}</p>
                    <p style={{fontSize: '1.2vw', lineHeight: 2}}>{brandInfo.introdution}</p>
                  </div>
                </div>
                <div className="brand--bottomImg">
                  <img
                    src={brandInfo.bannerImgUrl_bottom}
                    alt={brandInfo.name}
                    style={{width: '100%'}}
                  />
                </div>
                <div
                  style={{
                    background: brandInfo.bgColor_top,
                    padding: 50,
                    textAlign: 'center'
                  }}
                >
                  <img
                    src={brandInfo.logoUrl}
                    alt={brandInfo.logoUrl}
                    style={{ maxWidth: 260 }}
                  />
                </div>
              </div>
            </div>
          </main>
        </div>
      )}
    </>
  );
};

export default BrandPreview;
